import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type AppState = {
  organisationContextId: string | null;
};

const initialState: AppState = {
  organisationContextId: null,
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setOrganisationContextId(state, action: PayloadAction<string | null>) {
      state.organisationContextId = action.payload;
    },
  },
});

export const { setOrganisationContextId } = appSlice.actions;
export default appSlice.reducer;